import AvatarRobotz from "./parceiro_robotz.png";

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_robotiz.png",
      alt: "Nome da extensão",
    },
    title: "ROBOTZ: inteligência estatística para consistência com controle de risco ",
    text: [
      "Unimos décadas de experiência em finanças, estatística e tecnologia para oferecer carteiras e robôs ideais para qualquer portfólio. Temos skin in the game, profissionais com formação sólida e certificações internacionais, e gestão ativa, alinhando teoria, prática e compromisso com o resultado. ",
    ],
    testimonial: {
      text: "“Prezamos sempre pelo profissionalismo e transparência. Usamos nossas estratégias em nossas próprias contas, portanto você terá a certeza de uma gestão eficiente e próxima.” ",
      author: {
        name: "Rogerio Szterling, fundador da ROBOTZ ",
        // picture: "https://i.pravatar.cc/150?img=70",
        picture: AvatarRobotz,
      },
    },
  },
  features: {
    title: "Por que utilizar os robôs da ROBOTZ?",
    subtitle: "Veja quais as principais vantagens dos robôs da ROBOTZ.",
    data: [
      {
        title: "Autonomia com disciplina",
        description:
          "Os robôs operam com total independência, sem precisar de sua presença. Executam estratégias com consistência, evitando distrações, erros humanos e perda de oportunidades por falta de tempo. ",
      },
      {
        title: "Controle emocional",
        description:
          "Eliminam decisões impulsivas e “dias de fúria”. O robô segue o plano à risca, sem deixar que medo, ganância ou ansiedade prejudiquem os resultados da estratégia. ",
      },
      {
        title: "Execução avançada",
        description:
          "Com rapidez, precisão e sem hesitação, os robôs garantem entradas e saídas corretas, otimizam o timing e reduzem spreads — tudo mais rápido e eficiente que qualquer humano.",
      },
      {
        title: "Diversificação e escalabilidade",
        description:
          "Permitem aplicar múltiplas estratégias simultaneamente, com diferentes perfis e horizontes. Com isso, ajudam a equilibrar risco e potencializar a performance da carteira como um todo. ",
      },
      {
        title: "Gestão de risco inteligente",
        description:
          "Aplicam limites, filtros e proteções automaticamente, evitando operações fora do plano. Incluem controles como volatilidade, volume e horários críticos — impossíveis de monitorar manualmente com precisão.",
      },
      {
        title: "Acesso a inteligência de mercado",
        description:
          "Você opera com modelos baseados em anos de experiência e testes estatísticos robustos, desenvolvidos por especialistas certificados. É como ter um time de traders profissionais ao seu lado. ",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar? Ative agora e deixe a execução das estratégias por nossa conta!",
    subtitle: "Ativa ROBOTZ.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Robotz",
    col1: [
      "Criada para oferecer robustez e inteligência em um mercado cada vez mais dinâmico, a ROBOTZ nasceu da união entre tecnologia de ponta e décadas de experiência prática no setor financeiro. ",
      "Com algoritmos próprios, desenvolvidos para operar de forma eficiente em diferentes cenários de mercado, nossos robôs são projetados para reduzir riscos, melhorar a diversificação e se encaixar perfeitamente em qualquer estratégia de investimento. ",
    ],
    col2: [
      "À frente da ROBOTZ está um profissional com mais de 30 anos de experiência — Engenheiro de Computação, planejador financeiro, MBA e analista CNPI — com sólida base em estatística e gestão de risco, liderando o desenvolvimento de estratégias focadas em consistência e segurança de longo prazo.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Robotz",
  },
  strategies: {
    title: "ROBOTZ: Carteiras e robôs individuais",
    heading: "Estratégias com rigor estatístico e gestão ativa ",
    subtitle:
      "Desenvolvidas usando dados históricos reais desde 2015, nossas estratégias apresentaram robustez nos mais diferentes ciclos de mercado. Você só precisa escolher a carteira ou robô desejado — a execução fica por nossa conta! ",
  },
  testimonials: [
    {
      text: '"Sou cliente da Robotz há um bom tempo e recomendo sem hesitar. As estratégias são consistentes, o suporte é rápido e técnico, e a transparência da empresa passa muita confiança. É raro encontrar esse nível de seriedade no mercado." ',
      author: "Joscelino Oliveira ",
      job: "Trader Profissional",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: '"Eu utilizo as estratégias Magníficos e Splinter há alguns meses. Nesse período pude perceber a seriedade aplicada no trabalho, além da transparência e competência indiscutíveis. Recomendo 100%" ',
      author: "Alexandre Guanho",
      job: "Empresário",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: '"Estou muito feliz com o serviço da Robotz! O pessoal é super sério, trabalha duro e cuida de tudo com muita responsabilidade. As estratégias de automação realmente funcionam e me deixaram tranquilo para focar em outras coisas. Recomendo demais!" ',
      author: "Roberto Krohn",
      job: "Militar",
    },
    {
      text: '"Trabalhar com a ROBOTZ é incrível! As estratégias são consistentes e o atendimento é sempre transparente e atencioso. Já vi resultados concretos e recomendo fortemente!" ',
      author: "Luiz Felipe Braga Ribeiro",
      job: "Empresário",
    },
  ],
};
